import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'whatsappFormat'
})
export class WhatsappFormatPipe implements PipeTransform {

  constructor(private sanitizer: DomSanitizer) { }

  transform(value: string): any {
    if (!value) return '';

    let text = value.replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');

    // monospace
    text = text.replace(/```([\s\S]+?)```/g, '<pre><code>$1</code></pre>');

    // bold
    text = text.replace(/\*([^*]+)\*/g, '<strong>$1</strong>');

    // italic
    text = text.replace(/_([^_]+)_/g, '<em>$1</em>');

    // strike
    text = text.replace(/~([^~]+)~/g, '<s>$1</s>');

    return this.sanitizer.bypassSecurityTrustHtml(text.replace(/\n/g, '<br>'));
  }

}
